'use client';
import { RiShoppingBag2Fill } from 'react-icons/ri';

import { usePathname, useRouter } from '@/i18n/routing';

export default function BuyButton({ text }) {
  const router = useRouter();
  let pathName = usePathname();

  return (
    <button
      className="btn-buy-now flex gap-x-3 justify-center p-1 relative hover:cursor-pointer"
      onClick={() => {
        localStorage.clear();
        if (pathName.includes('/market-size')) {
          pathName = pathName.replace('/market-size', '/buynow');
          router.push(pathName);
        } else if (pathName.includes('/market-trends')) {
          pathName = pathName.replace('/market-trends', '/buynow');
          router.push(pathName);
        } else if (pathName.includes('/market-share')) {
          pathName = pathName.replace('/market-share', '/buynow');
          router.push(pathName);
        } else if (pathName.includes('/companies')) {
          pathName = pathName.replace('/companies', '/buynow');
          router.push(pathName);
        } else {
          router.push(`${pathName}/buynow`);
        }
      }}
    >
      <RiShoppingBag2Fill className="my-auto" />
      <span>{text}</span>
    </button>
  );
}
